export default {
    getDeviceFilters: state => {
        return state.devicesManagement.devicesFilters
    },
    getFleetFilters: state => {
        return state.fleetManagement.fleetFilters
    },
    getUserFilters: state => {
        return state.userManagement.userFilters
    },
    getDriverFilters: state => {
        return state.driverManagement.driverFilters
    },
    getOrganizationFilters: state => {
        return state.organizationsManagement.organizationsFilters
    }
}
